import { bulkDocumentDownloadConfiguration } from './BulkDocumentDownload/configurations/BulkDocumentDownload.configuration.js';
import { documentDownloadConfiguration } from './DocumentDownload/configurations/DocumentDownload.configuration.js';
import { documentDownloadListConfiguration } from './DocumentDownloadList/configurations/DocumentDownloadList.configuration.js';
import { documentTileConfiguration } from './DocumentTile/configurations/DocumentTile.configuration.js';
import { documentTilesConfiguration } from './DocumentTiles/configurations/DocumentTiles.configuration.js';
import { IFileConfiguration } from './IFileConfiguration.js';
/* [Component: import] */
/* [ChartComponent: import] */

export const fileConfiguration: IFileConfiguration = {
	documentDownload: documentDownloadConfiguration,
	documentDownloadList: documentDownloadListConfiguration,
	bulkDocumentDownload: bulkDocumentDownloadConfiguration,
	documentTile: documentTileConfiguration,
	documentTiles: documentTilesConfiguration,
	/* [Component: interface] */
	/* [ChartComponent: interface] */
};
